// extracted by mini-css-extract-plugin
export default {"root":"styles_root__0VNT3","navContainer":"styles_navContainer__vfWjs"};